import axios from 'axios';

export const sendEmailAPI = () => axios.post(`{server}/admin/forgot`).then(res => res.data.success)
export const resetPasswordAPI = ({token, password, rePassword}) => axios.post(`{server}/admin/reset?token=${token}`, {password, confirmPassword: rePassword}).then(res => res.data.success)